/**
 * Minimal, consistent crop silhouettes used as a faint natural-colour backdrop watermark on
 * crop cards. Single-colour (currentColor) so they can be tinted per crop (see cropColor).
 * Decorative only.
 */
const ART: Record<string, React.ReactNode> = {
  grape: (
    <>
      <path d="M35 13c3-4 8-5 12-3-1 5-6 8-11 6" />
      <rect x="30.5" y="10" width="3" height="9" rx="1.5" />
      <circle cx="23" cy="27" r="6" />
      <circle cx="41" cy="27" r="6" />
      <circle cx="16" cy="38" r="6" />
      <circle cx="32" cy="36" r="6" />
      <circle cx="48" cy="38" r="6" />
      <circle cx="24" cy="48" r="6" />
      <circle cx="40" cy="48" r="6" />
      <circle cx="32" cy="57" r="6" />
    </>
  ),
  pomegranate: (
    <>
      <circle cx="32" cy="40" r="17" />
      <path d="M32 9c1.5 2 2 5 1.5 8-1-.3-2-.3-3 0C30 14 30.5 11 32 9Z" />
      <path d="M24 12c2 1.5 3 4 3 7-1 .2-2 .6-2.8 1.2C22.6 18 22.5 15 24 12Z" />
      <path d="M40 12c-2 1.5-3 4-3 7 1 .2 2 .6 2.8 1.2C41.4 18 41.5 15 40 12Z" />
    </>
  ),
  citrus: (
    <>
      <path d="M42 12c4-2 9-1 11 2-2 4-7 6-11 4" />
      <circle cx="30" cy="40" r="18" />
      <circle cx="30" cy="40" r="12" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M30 28v24M18 40h24M22 31l16 18M38 31L22 49" stroke="currentColor" strokeWidth="1.6" fill="none" />
    </>
  ),
  banana: (
    <>
      <path d="M23 13c-1 3-.5 5 .6 7 3.4 11.4 12.6 20 24.4 21.4-2 5.6-7.4 9.6-14.6 9.6C20 51 9 40 9 27c0-7.4 6-13.4 14-14Z" />
      <path d="M20 11c1.4-2.4 4-4 6.6-4-1 2.6-3 4.6-5.4 5.6z" />
      <circle cx="47" cy="41" r="2.4" />
    </>
  ),
  tomato: (
    <>
      <circle cx="32" cy="40" r="18" />
      <path d="M32 12l3 6 6-3-2 6 6 1-6 3M32 12l-3 6-6-3 2 6-6 1 6 3" />
      <rect x="30.5" y="9" width="3" height="8" rx="1.5" />
    </>
  ),
  chilli: (
    <>
      <path d="M20 20c6-1 11 2 15 8 4 6 6 14 3 22-2 5-7 6-10 2-2-3-1-6 1-7 3-2 3-6 1-10-3-6-8-9-12-9-1-3 0-6 2-6Z" />
      <path d="M18 16c3-3 8-3 11 0-2 2-4 3-6 3M18 16c-2 2-2 5 0 7 1-2 2-4 4-5" />
    </>
  ),
  potato: (
    <>
      <path d="M18 34c-3-6 1-13 8-15 5-1 8 1 13 1 6 0 11 4 11 10 0 7-5 13-13 15-4 1-7 0-11-1-4-1-6-5-8-10Z" />
      <circle cx="26" cy="34" r="1.6" />
      <circle cx="36" cy="30" r="1.6" />
      <circle cx="38" cy="40" r="1.6" />
      <circle cx="30" cy="42" r="1.6" />
    </>
  ),
  onion: (
    <>
      <path d="M32 20c-3-4-2-9 2-12-1 4 0 7 2 9M32 20c3-4 2-9-2-12 1 4 0 7-2 9" />
      <path d="M32 20c-10 0-16 8-16 18 0 9 7 16 16 16s16-7 16-16c0-10-6-18-16-18Z" />
      <path d="M24 24c-2 8-2 18 2 27M40 24c2 8 2 18-2 27M32 22v32" fill="none" stroke="#000" strokeOpacity="0" />
    </>
  ),
  sugarcane: (
    <>
      <rect x="16" y="12" width="6" height="44" rx="3" />
      <rect x="29" y="8" width="6" height="48" rx="3" />
      <rect x="42" y="14" width="6" height="42" rx="3" />
      <path d="M22 6c4 0 8 2 10 5-4 1-8 0-10-2M35 4c-4 0-8 2-10 5 4 1 8 0 10-2M48 8c-4 0-8 2-10 5 4 1 8 0 10-2" />
    </>
  ),
  cotton: (
    <>
      <circle cx="24" cy="24" r="9" />
      <circle cx="40" cy="24" r="9" />
      <circle cx="32" cy="18" r="9" />
      <circle cx="32" cy="30" r="9" />
      <path d="M20 38l12-6 12 6-3 14H23z" />
    </>
  ),
  'wheat-paddy': (
    <>
      <path d="M31 56V24" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M32 10c-3 2-4 6-3 10 3-1 5-5 3-10ZM32 10c3 2 4 6 3 10-3-1-5-5-3-10Z" />
      <path d="M26 20c-3 1-5 4-5 8 3 0 6-2 7-6ZM38 20c3 1 5 4 5 8-3 0-6-2-7-6Z" />
      <path d="M24 30c-3 1-5 4-5 8 3 0 6-2 7-6ZM40 30c3 1 5 4 5 8-3 0-6-2-7-6Z" />
      <path d="M23 40c-3 1-5 4-5 8 3 0 6-2 7-6ZM41 40c3 1 5 4 5 8-3 0-6-2-7-6Z" />
    </>
  ),
  'turmeric-ginger': (
    <path d="M16 40c-4-2-6-7-3-10 3-3 7-1 9 1 0-5 4-8 9-7 3 1 4 4 3 7 4-2 9 0 10 4 2 4-1 8-5 8 0 4-4 7-8 6-2-1-3-3-3-5-4 2-9 0-11-4Z" />
  ),
}

const FALLBACK = (
  <path d="M46 10C44 30 35 48 20 52c-6 1-11-2-11-2S9 22 30 12c8-3 16-2 16-2Z" />
)

interface CropArtProps {
  slug: string
  className?: string
  style?: React.CSSProperties
}

export function CropArt({ slug, className, style }: CropArtProps) {
  return (
    <svg viewBox="0 0 64 64" className={className} style={style} fill="currentColor" aria-hidden="true">
      {ART[slug] ?? FALLBACK}
    </svg>
  )
}
